import { render, staticRenderFns } from "./AddComponentPicker.vue?vue&type=template&id=07d41b5c&scoped=true"
import script from "./AddComponentPicker.vue?vue&type=script&lang=js"
export * from "./AddComponentPicker.vue?vue&type=script&lang=js"
import style0 from "./AddComponentPicker.vue?vue&type=style&index=0&id=07d41b5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d41b5c",
  null
  
)

export default component.exports